import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { RemoteDeleteTourProgram } from "../../../data/usecases/monthly-tour-program/remote-delete-tour-program";

export interface DeleteTourProgramInterface {
  DeleteTourProgramState: FetchState;
  deleteTourProgram: Function;
}

const initialStates = {
  DeleteTourProgramState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useDeleteTourProgramSlice: StateCreator<
  DeleteTourProgramInterface
> = (set) => ({
  ...initialStates,
  deleteTourProgram: async (
    id: number
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteDeleteTourProgram = new RemoteDeleteTourProgram(
      `${BASE_URL}${Endpoints.FETCH_DELETE_TOUR_PROGRAM}`,
      axiosHttpClient
    );

    set(() => ({ DeleteTourProgramState: FetchState.LOADING }));
    let result = await remoteDeleteTourProgram.delete(id.toString());
    return result;
  },
});
